<template>
  <div>
    <div>
      <div class=" bg-white border border-border rounded-md lg:mb-5 mb-4 lg:hidden" v-if="(state.opt_type == 'general' && state.enroll_option == 'individual')">
        <div class="p-4 flex items-start justify-start gap-4">
          <span
            class="w-[50px] h-[50px] bg-primaryLight border border-border flex rounded-md items-center justify-center shrink-0">
            <img src="@/assets/images/info.svg" alt="info">
          </span>
          <div>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              This application is to enroll as an individual, which means that you are not
              affiliated
              with
              a company that partners with us.
            </p>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              To inquire if your company is a partner with U.S. Legal, please email <a href="info@uslegalservices.net"
                class="text-blackPrimary">info@uslegalservices.net</a>
              or contact our Member
              Care
              Team at (800) 356-LAWS (5297).
            </p>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              Currently, individual enrollments are only accepted for the CDL Defender.
            </p>
          </div>
        </div>
      </div>
      <div class="bg-white border border-border rounded-md lg:mb-5 mb-4"
  v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
  <div class="flex w-full !m-0 p-4 gap-[8px] lg:items-center flex-col lg:flex-row items-start">

    <div class="flex xl:items-center gap-[8px] w-full items-baseline">
      <span class="number-badge">1</span>

      <h6 class="card-title !m-0 flex items-center gap-2">
        Do you have a Commercial Driver's License (CDL)?

        <!-- Info Tooltip -->
        <div class="info-wrapper relative inline-block group">
          <span class="info-icon">i</span>

          <!-- Tooltip box -->
          <div class="tooltip-box hidden group-hover:block">
            <div class="tooltip-title">What is a Commercial Driver's License (CDL)?</div>
            <div class="tooltip-body">
              You have a Commercial Driver's License (CDL) if you are licensed to drive
              large or specialized vehicles like tractor-trailers, buses, or vehicles
              carrying hazardous materials. <br><br>
              If your license is a standard passenger license for personal vehicles
              (cars, SUVs, pickup trucks), you do not have a CDL.
            </div>

            <!-- Arrow -->
            <div class="tooltip-arrow"></div>
          </div>
        </div>

      </h6>
    </div>

    <div class="field-rep-block flex items-center gap-[16px] ms-[27px] lg:ms-0">
      <div class="field-radio-block">
        <label class="radio radio-outline-primary field-radio !mb-0">
          <input type="radio" :checked="false"
            @change="onHasCDLChange('yes')"
            name="hasCDL" value="yes" />
          <span>Yes</span><span class="checkmark"></span>
        </label>
      </div>

      <div class="field-radio-block">
        <label class="radio radio-outline-primary field-radio !mb-0">
          <input type="radio" :checked="false"
            @change="onHasCDLChange('no')"
            name="hasCDL" value="no" />
          <span>No</span><span class="checkmark"></span>
        </label>
      </div>
    </div>

  </div>
</div>

      <!-- <div v-if="state.hasCDL === 'no'" class="bg-white border border-border rounded-md lg:mb-5 mb-4">
        <div class="text-center p-4 md:w-[400px] w-auto mx-auto">
          <span
            class="w-[60px] h-[60px] rounded-full flex items-center justify-center border bg-[#fff2f2] border-border mx-auto mb-4">
            <img src="@/assets/images/warning-info.svg" alt="info" />
          </span>
          <h6 class="font-bold text-blackPrimary text-lg">We're Sorry</h6>
          <p class="content !m-0">{{ state.eligibilityMessage }}</p>
           <br>
          <h6 class="font-bold text-blackPrimary text-lg" v-if="state.opt_type == 'general'">Coming Soon</h6>
          <p class="content !m-0" v-if="state.opt_type == 'general'">We will soon be accepting individual enrollments for our Family and Identity Defender plans! Please check back at a later date. </p>        </div>
      </div> -->
    </div>
    <div class="bg-white border border-border rounded-md lg:mb-5 mb-4"
      v-if="(state.enroll_option == 'affilliated' && state.opt_type == 'general' || state.opt_type == 'SEIU721')">
      <div class="flex w-full border-b border-border !m-0 p-4 gap-[8px] items-center">
        <span class="number-badge">1</span>
        <h6 class="card-title !m-0">Union Member Information</h6>
      </div>
      <div class="p-4">
        <div class="form-group mb-4 flex items-center justify-start gap-[16px]">
          <label class="font-normal text-mute text-sm mb-0 inline-block">
            Are you a SEIU721 Union Member?<span class="text-error">*</span>
          </label>
          <div class="flex items-center gap-[20px]">
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" :checked="state.isSEIU === 'yes'"
                  @change="$emit('updateState', { key: 'isSEIU', value: 'yes' })" name="isSEIU"
                  value="yes" /><span>Yes</span><span class="checkmark"></span>
              </label>
            </div>
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" name="isSEIU" @change="$emit('updateState', { key: 'isSEIU', value: 'no' })"
                  value="no" /><span>No</span><span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="state.isSEIU === 'no'" class="bg-white border border-border rounded-md lg:mb-5 mb-4">
          <div class="text-center p-4 md:w-[400px] w-auto mx-auto">
            <span
              class="w-[60px] h-[60px] rounded-full flex items-center justify-center border bg-[#fff2f2] border-border mx-auto mb-4">
              <img src="@/assets/images/warning-info.svg" alt="info" />
            </span>
            <h6 class="font-bold text-blackPrimary text-lg">We're Sorry</h6>
            <p class="content !m-0">
              To confirm Union Membership or to become a Member of the Union, please contact a SEIU721 Membership
              Analyst at membership@SEIU721.org or call (213) 251-3757. You may also click the following link to become
              a member or verify membership <u class="text-blue-500"><a
                  href="https://www.seiu721.org/create-account.php"
                  target="_blank">https://www.seiu721.org/create-account.php</a></u>
            </p>
          </div>
        </div>
        <!-- <div class="form-group mb-4" v-if="state.isSEIU=='yes'">
        <label class="font-normal text-mute text-sm mb-2 inline-block">
            Do you wish to enroll in the Family Defender plan?<span class="text-error">*</span>
          </label>
          <div class="field-radio-block">
            <label class="radio radio-outline-primary field-radio !mb-0">
              <input type="radio" :checked="state.isFAM === 'yes'"
                @change="$emit('updateState', { key: 'isFAM', value: 'yes' })" name="isFAM"
                value="yes" /><span>Yes</span><span class="checkmark"></span>
            </label>
          </div>
          <div class="field-radio-block">
            <label class="radio radio-outline-primary field-radio !mb-0">
              <input type="radio" name="isFAM" @change="$emit('updateState', { key: 'isFAM', value: 'no' })"
                value="no" /><span>No</span><span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div v-if="state.isFAM === 'no'" class="bg-white border border-border rounded-md lg:mb-5 mb-4">
      <div class="text-center p-4 md:w-[400px] w-auto mx-auto">
        <span
          class="w-[60px] h-[60px] rounded-full flex items-center justify-center border bg-[#fff2f2] border-border mx-auto mb-4">
          <img src="@/assets/images/warning-info.svg" alt="info" />
        </span>
        <h6 class="font-bold text-blackPrimary text-lg">We're Sorry</h6>
        <p class="content !m-0">
          you decided not to enroll in the Family Defender plan. If you change your mind and decide to join click here <u class="text-blue-500"><a href="https://www.uslegalservices.net/companies/seiu721" target="blank">https://www.uslegalservices.net/companies/seiu721</a></u>.

        </p>
      </div>
    </div> -->
        <div class="form-group" v-if="state.isSEIU == 'yes' && state.isFAM == 'yes'">
          <label class="font-normal text-mute text-sm mb-2 inline-block">
            Select Company<span class="text-error">*</span>
          </label>
          <select id="company" name="company" v-model="selectedCompany" @change="updateSelectedCompany"
            class="form-mask">
            <option v-for="company in state.companies" :key="company.id" :value="company">
              {{ company.company_name }}
            </option>
          </select>
          <small class="mt-[8px] block text-mute text-xs font-normal">
            If you do not see your employer in this drop-down list, please contact a SEIU721 Membership Analyst at
            membership@SEIU721.org or call (213) 251-3757 to confirm if you are able to enroll.
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: Object,
  },
  data() {
    return {
      selectedCompany: null, // Local variable for v-model
    };
  },
  methods: {
    updateSelectedCompany() {
      this.$emit('updateState', { key: 'company', value: this.selectedCompany });
      this.$emit('updateState', { key: 'company_number', value: this.selectedCompany.company });
    },

    // ⭐ NEW FUNCTION — This refreshes plans when hasCDL changes
    onHasCDLChange(value) {
      // Update state
      this.$emit('updateState', { key: 'hasCDL', value });

      // Reset UI state
      this.$emit('updateState', { key: 'disp_enroll_section', value: false });

      // Tell parent to re-fetch plans
      this.$emit('getPlanListAgain');
    }
  }
};
</script>

<style scoped>
/* Add any necessary styles here */
.info-box {
  /* Styles for the additional info box */
}

.info-message {
  /* Styles for the message shown when 'No' is selected */
}
.info-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid #ce4c29;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  color: #ce4c29;
  line-height: 1;
  text-transform: lowercase;
}

.tooltip-box {
  position: absolute;
  top: -40px;
  left: 40px;
  width: 300px;
  background: #f8fdfd;
  border: 1.5px solid #1a1a1a;
  border-radius: 6px;
  z-index: 50;
  color: #333;
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
  overflow: hidden;
}

.tooltip-title {
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  color: #1a1a1a;
  padding: 12px;
  background-color: #d9f9f9;
}

.tooltip-body {
  font-size: 13px;
  line-height: 18px;
  color: #1a1a1a;
  padding: 12px;
  font-weight: 500;
  background-color: #ffffff;
}

/* Arrow */
.tooltip-arrow {
  display: none;
  position: absolute;
  top: -8px;
  left: 30px;
  width: 14px;
  height: 14px;
  background: #f8fdfd;
  border-top: 1.5px solid #b9e3df;
  border-left: 1.5px solid #b9e3df;
  transform: rotate(45deg);
}
@media (max-width: 991px) {
  .tooltip-box {
    left: auto;
    right: 0;
    top: 40px;
  }
}

</style>